// v10/src/services/inventoryService.js
//
// Servicios de Stock de repuestos (A8). Wrapper del axios `api` que ya maneja
// JWT, refresh automático e impersonación de SuperAdmin.
//
// Tarea 1 (lectura): se consumen `list`, `dashboard`, `alerts` y, vía
// apiService directo, /api/aircraft para el selector. El resto queda definido
// para que la Tarea 2 (modales y movimientos) los use sin modificar este archivo.

import api from './apiService';

const inventoryService = {
  // ── Items (lectura) ──────────────────────────────────────────────
  list:                 (params = {}) => api.get('/api/inventory-items', { params }),
  getById:              (id)          => api.get(`/api/inventory-items/${id}`),
  dashboard:            ()            => api.get('/api/inventory-items/dashboard'),
  alerts:               ()            => api.get('/api/inventory-items/alerts'),
  listSerializedByItem: (itemId)      => api.get(`/api/inventory-items/${itemId}/serialized`),

  // Vinculación A6.1 ↔ A8: productos compatibles con la aeronave (vía
  // inventory_compatibilities) + universales. Filtro opcional por
  // categoría de A8 para sugerir un subconjunto en el modal de reemplazo.
  getCompatibleWithAircraft: (aircraftId, category = null) => {
    const url = category
      ? `/api/inventory-items/compatible-with-aircraft/${aircraftId}?category=${encodeURIComponent(category)}`
      : `/api/inventory-items/compatible-with-aircraft/${aircraftId}`;
    return api.get(url);
  },

  // ── Templates (lectura) ──────────────────────────────────────────
  listTemplates: (params = {}) => api.get('/api/inventory-templates', { params }),

  // ── Movimientos (lectura) ────────────────────────────────────────
  listMovements:   (params = {}) => api.get('/api/inventory-movements', { params }),
  getMovementById: (id)          => api.get(`/api/inventory-movements/${id}`),

  // ── Items (escritura — Tarea 2) ──────────────────────────────────
  create:      (data)     => api.post('/api/inventory-items', data),
  update:      (id, data) => api.put(`/api/inventory-items/${id}`, data),
  delete:      (id)       => api.delete(`/api/inventory-items/${id}`),
  uploadPhoto: (id, data) => api.post(`/api/inventory-items/${id}/photo`, data),
  deletePhoto: (id)       => api.delete(`/api/inventory-items/${id}/photo`),

  // ── Compatibilidades (escritura — Tarea 2) ───────────────────────
  addCompatibility:    (id, data)     => api.post(`/api/inventory-items/${id}/compatibilities`, data),
  removeCompatibility: (id, compatId) => api.delete(`/api/inventory-items/${id}/compatibilities/${compatId}`),

  // ── Movimientos (escritura — Tarea 2) ────────────────────────────
  createMovement: (data) => api.post('/api/inventory-movements', data),

  // ── Serialized items (escritura — Tarea 2) ───────────────────────
  createSerialized: (itemId, data) => api.post(`/api/inventory-items/${itemId}/serialized`, data),
  updateSerialized: (id, data)     => api.put(`/api/inventory-serialized/${id}`, data),
  deleteSerialized: (id)           => api.delete(`/api/inventory-serialized/${id}`),
};

export default inventoryService;
